import { createApp } from 'vue'
import App from './App.vue'

// Uygulama oluştur
const app = createApp(App)

// Uygulamayı başlat
app.mount('#app')